import styled from 'styled-components'
import { BREAKPOINT_MEDIUM, Button } from '@big-red-group/storefront-common-ui'
import { ModalItem } from './BookingStepsContainer.styles'
import { InputWrapper } from './Input.styles'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`
export const Image = styled.div`
  background-position: center center;
  background-size: cover;
  width: 144px;
  height: 116px;
  flex-shrink: 0;
  margin-right: 16px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`

export const BookingSteps = styled.div`
  box-sizing: border-box;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${ModalItem} {
    padding: 30px;
  }
`

export const BookingNotesWrapper = styled(InputWrapper)`
  width: 100%;
`

export const PricingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`

export const TotalWrapper = styled.div`
  font-weight: var(--font-medium);
  font-size: 24px;

  > span {
    font-size: 12px;
    margin-bottom: 5px;
    font-weight: var(--font-regular);
    display: block;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const Total = styled.div`
  font-weight: var(--font-bold);

  @media (max-width: 768px) {
    font-size: 26px;
  }
`

export const CheckAvailability = styled(Button)`
  white-space: nowrap;
  font-size: 14px;
  width: max-content;
  margin-left: auto;

  @media (max-width: 1100px) {
    width: 100%;
  }
`

export const BookingStepsWrapper = styled.div`
  border: 1px solid var(--grey-25);
  border-radius: 6px;
`

export const BookingStepWrapper = styled.div`
  padding: 35px;

  @media (max-width: 1000px) {
    padding: 20px 12px;
  }
`

export const CalendarAndOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  justify-content: space-between;
  box-sizing: border-box;
  background: #fafafa;
  padding: 30px;
  border-radius: 10px;

  @media (max-width: 1200px) {
    gap: 20px;
  }
  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 20px 12px;
  }
  @media (max-width: 500px) {
    width: calc(100% + 60px);
    left: -30px;
    position: relative;
    padding: 25px 5%;
    border-radius: 0;
  }
`

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  justify-content: flex-start;

  @media (max-width: 1200px) {
    width: 40%;
  }

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;

  @media (max-width: 1200px) {
    width: 60%;
  }
  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const IconWrapper = styled.div<{ fill?: string }>`
  color: var(--${({ fill }) => fill ?? 'brand-secondary-dark'});
  width: 14px;
  height: 14px;

  svg {
    width: 14px;
    height: 14px;
  }
`

export const SelectDateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`

export const FirstAvailableDate = styled.div`
  color: var(--grey-100);
  padding-left: 10px;
  border-left: 1px solid var(--grey-100);
  font-size: 13px;
  font-weight: var(--font-bold);
`

export const OptionalExtrasWrap = styled.div`
  padding: 35px 24px;
  border: 1px solid var(--grey-25);
  border-radius: 10px;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: calc(100% - 50px);
  margin: 0 auto 35px auto;
  box-sizing: border-box;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    padding: 0;
    border-width: 1px 0;
    padding: 30px 0;
    border-radius: 0;
  }
`
